import { IActionCode } from '@bca-shared/models/action-code';
import { IAddon } from '@bca-shared/models/addon';
import { IAgreement } from '@bca-shared/models/agreement';
import { ICompany } from '@bca-shared/models/company';
import { IProduct } from '@bca-shared/models/product';
import { IUser } from '@bca-shared/models/user';
import { IAction } from '@bca-store/models/action';

export enum ReceiptActionTypes {
  AddUser = '[Receipt] AddUser',
  DeleteUser = '[Receipt] DeleteUser',
  AddCompany = '[Receipt] AddCompany',
  DeleteCompany = '[Receipt] DeleteCompany',
  AddProduct = '[Receipt] AddProduct',
  DeleteProduct = '[Receipt] DeleteProduct',
  AddActionCode = '[Receipt] AddActionCode',
  DeleteActionCode = '[Receipt] DeleteActionCode',
  DeleteAddon = '[Receipt] DeleteAddon',
  SetVerifiedStatus = '[Receipt] SetVerifiedStatus',
  SetCompletedStatus = '[Receipt] SetCompletedStatus',
  AddAgreement = '[Receipt] AddAgreement',
  DeleteAgreement = '[Receipt] DeleteAgreement'
}

export class AddAgreement implements IAction {
  readonly type = ReceiptActionTypes.AddAgreement;
  constructor(public readonly payload: IAgreement) {}
}

export class DeleteAgreement implements IAction {
  readonly type = ReceiptActionTypes.DeleteAgreement;
}

export class DeleteAddon implements IAction {
  readonly type = ReceiptActionTypes.DeleteAddon;
  constructor(public readonly payload: { addon: IAddon; productId: number }) {}
}

export class AddActionCode implements IAction {
  readonly type = ReceiptActionTypes.AddActionCode;
  constructor(public readonly payload: IActionCode) {}
}

export class DeleteActionCode implements IAction {
  readonly type = ReceiptActionTypes.DeleteActionCode;
}

export class AddCompany implements IAction {
  readonly type = ReceiptActionTypes.AddCompany;
  constructor(public readonly payload: ICompany) {}
}

export class DeleteCompany implements IAction {
  readonly type = ReceiptActionTypes.DeleteCompany;
}

export class AddProduct implements IAction {
  readonly type = ReceiptActionTypes.AddProduct;
  constructor(public readonly payload: IProduct) {}
}

export class AddUser implements IAction {
  readonly type = ReceiptActionTypes.AddUser;
  constructor(public readonly payload: { user: IUser; productId: number }) {}
}

export class DeleteUser implements IAction {
  readonly type = ReceiptActionTypes.DeleteUser;
  constructor(public readonly payload: { productId: number }) {}
}

export class DeleteProduct implements IAction {
  readonly type = ReceiptActionTypes.DeleteProduct;
  constructor(public readonly payload: IProduct) {}
}

export class SetVerifiedStatus implements IAction {
  readonly type = ReceiptActionTypes.SetVerifiedStatus;
  constructor(public readonly payload: { verified: boolean }) {}
}

export class SetCompletedStatus implements IAction {
  readonly type = ReceiptActionTypes.SetCompletedStatus;
  constructor(public readonly payload: { completed: boolean }) {}
}

export type Action =
  | AddProduct
  | AddUser
  | DeleteUser
  | DeleteProduct
  | AddCompany
  | DeleteCompany
  | DeleteAddon
  | SetVerifiedStatus
  | SetCompletedStatus
  | AddActionCode
  | DeleteActionCode
  | DeleteAgreement
  | AddAgreement;
